/**
 * created by xcc on 2022/4/21
 * 用户管理新增页面
 */

import React, {Component} from 'react';
import {
    Button,
    Modal,
    Input,
    Row,
    Col, Select,
} from "antd";
import {message} from "../../sysManagement/utils/sysManagementUtils";
import {userManageAdd, userManageUpdate} from "../actions/newUserManagement";
import SelectUserModal from "./SelectUserModal";

const {Option} = Select;
let windowKeyup;
export default class NewUserAdd extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            title: "",
            selectSearchValue: "",
            mediaRoleIds: undefined,
            userInfo: [],
            id: "",
            deptId: window.top.currentUser.deptIds[0]
        }
    }

    componentWillMount() {

    }

    componentDidMount() {
        this.props.onRef(this);
    }

    /**
     * 渲染
     */
    render() {
        let userName = [];
        let userAccount = [];
        this.state.userInfo.length && this.state.userInfo.forEach(item => {
            userName.push(item.name);
            userAccount.push(item.account);
        })
        return (
            <div style={{padding: 20}}>
                {/*新增弹窗*/}
                <Modal
                    title={this.props.title}
                    visible={this.props.addVisible}
                    width={800}
                    height={572}
                    zIndex={500}
                    onCancel={() => {
                        this.props.onCancelAdd();
                    }}
                    maskClosable={false}
                    centered
                    footer={
                        <div style={{textAlign: "center"}}>
                            <Button onClick={() => {
                                this.props.onCancelAdd();
                            }}>取消</Button>
                            <Button type={"primary"} onClick={() => {
                                this.saveMedia()
                            }}>保存</Button>
                        </div>
                    }
                >
                    <div>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}><span
                                        style={{color: 'red', position: 'absolute', top: 3, left: 40}}>*</span>用户：
                                    </div>
                                </Col>
                                <Col span={19}>
                                    <Input onClick={() => {
                                        this.setState({
                                            visible: true,
                                            title: "选择用户"
                                        })
                                        this.selectUserModal.state.keywords = "";
                                        this.selectUserModal.state.page = 1;
                                        this.selectUserModal.getDeptUser();
                                    }} placeholder={"请选择用户"} className={'mediaAdministerContent'}
                                           value={userName.join(", ")}
                                           disabled={this.state.id ? true : false}
                                    />
                                    <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: 10, position: "relative"}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}>账号：</div>
                                </Col>
                                <Col span={19}>
                                    <Input placeholder={"账号自动获取"} className={'mediaAdministerContent'}
                                           value={userAccount.join(", ")}
                                           disabled={true}
                                    />
                                    <style>{`.ant-input{border: 1px solid #EEF2FB;}`}</style>
                                </Col>
                            </div>
                        </Row>
                        <Row>
                            <div style={{padding: 10}}>
                                <Col span={3}>
                                    <div className={'myMediaTitle'}><span
                                        style={{color: 'red', position: 'absolute', top: 3, left: 11}}>*</span>媒体角色：
                                    </div>
                                </Col>
                                <Col span={19}>
                                    <Select
                                        className={'mediaAdministerContent'}
                                        showSearch
                                        mode={"multiple"}
                                        placeholder={"请选择媒体角色"}
                                        defaultActiveFirstOption={false}
                                        showArrow={false}
                                        //需要加过滤属性，否则下拉后按上下键选中会有间断问题
                                        filterOption={(inputValue, option)=>option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0}
                                        value={this.state.mediaRoleIds}
                                        defaultValue={this.state.mediaRoleIds}
                                        onSearch={(value) => {
                                            this.setState({selectSearchValue: value, mediaRoleIds: undefined})
                                        }}
                                        onChange={(e) => {
                                            this.state.mediaRoleIds = e;
                                            this.setState({
                                                selectSearchValue: ""
                                            })
                                        }}
                                        style={{width: '100%'}}
                                        notFoundContent={null}
                                    >
                                        {this.props.mediaRoleList && this.props.mediaRoleList.length > 0 && this.props.mediaRoleList.map((item, i) => {
                                            let showOption = true;
                                            if (this.state.selectSearchValue && this.state.selectSearchValue.length > 0) {
                                                showOption = item.name.indexOf(this.state.selectSearchValue) > -1;
                                            }
                                            return (
                                                <Option key={i} value={item.id}
                                                        style={{display: showOption ? 'block' : 'none'}}>{item.name}</Option>
                                            )

                                        })

                                        }
                                    </Select>
                                </Col>
                            </div>
                        </Row>
                    </div>
                </Modal>
                {/*选择用户弹窗*/}
                <SelectUserModal
                    visible={this.state.visible}
                    modalTitle={this.state.title}
                    onRef={(c) => this.selectUserModal = c}
                    onCancel={() => {
                        this.setState({
                            visible: false
                        })
                    }}
                    onOk={(userData) => {
                        this.onOk(userData)
                    }}
                    userInfo={this.state.userInfo}
                />
            </div>
        )
    }

    onOk(userData) {
        if (userData.length === 0) {
            message.error("无用户可供选择");
            return;
        }
        if (userData.length > 0 && userData.every((item) => {
            return item.checked === false
        })) {
            message.error("请选择用户");
            return;
        }
        let userInfo = [];
        userData.forEach(item => {
            if (item.checked) {
                userInfo.push({name: item.name, id: item.id, account: item.account});
            }
        })
        this.setState({
            userInfo,
            visible: false
        });
    }

    saveMedia() {
        //校验
        if (!this.state.userInfo || this.state.userInfo.length === 0) {
            message.error("请选择用户");
            return;
        }
        if (!this.state.mediaRoleIds || this.state.mediaRoleIds.length === 0) {
            message.error("请选择媒体角色");
            return;
        }
        //保存
        this.saveData();
    }

    saveData() {
        let {userInfo} = this.state;
        let params = {
            "mediaRoleIds": this.state.mediaRoleIds,
            "userAccount": userInfo[0].account,
            "userId": userInfo[0].id,
            "userName": userInfo[0].name
        };
        params.deptId = this.state.deptId;
        if (this.state.id) {
            params.id = this.state.id;
            userManageUpdate(params, (data) => {
                if (data) {
                    message.success("修改成功");
                    this.props.getUserManageList();
                    this.props.onCancelAdd();
                } else {
                    message.error("修改失败");
                }
            })
        } else {
            userManageAdd(params, (data) => {
                if (data) {
                    message.success("新增成功");
                    this.props.getUserManageList();
                    this.props.onCancelAdd();
                } else {
                    message.error("新增失败");
                }
            })
        }
    }

    getDetail(item) {
        let userInfo = [];
        userInfo.push({
            id: item.userId,
            account: item.userAccount,
            name: item.userName
        })
        this.setState({
            mediaRoleIds: item.mediaRoleIds,
            userInfo,
            id: item.id,
            deptId: item.deptId
        })
    }

    revert() {
        this.setState({
            userInfo: [],
            selectSearchValue: "",
            mediaRoleIds: undefined,
            id: "",
            deptId: ""
        })
    }
}